import { useRouter } from "next/router"
import React from "react"
import {
  AvailabilitySearchResultsAggregations,
  CatalogProductDocument,
} from "../../../api/backend/backend-api"
// import { searchProductsQuery } from "../../../api/backend/products/api"
import { toPartialGridItemProduct } from "../../../converters/carousel"
import { newUuid } from "../../../utils"
import { SearchProvider } from "../context"
import { mergeFilters, toSearchFilters } from "../converters/filters"
import { SearchControllerParams, SearchOperation } from "../types"
import { AvailabilitySearchFilters } from "../../../containers/serp/types"

const searchProductsQuery: any = () => {}

interface Props {
  children: any
  searchParams?: SearchControllerParams
  initialFilters?: AvailabilitySearchFilters
  onNextCursorChange: (value: string | undefined) => void
}

const DEFAULT_PAGE_SIZE = 16

export const SearchController = ({
  children,
  searchParams,
  initialFilters,
  onNextCursorChange,
}: Props) => {
  const router = useRouter()
  const [operation, setOperation] = React.useState<SearchOperation>({
    called: false,
    loading: true,
    ready: false,
    isLastResultsPage: false,
  })

  const handleSearch = async (operationId: string) => {
    if (!searchParams || !initialFilters) {
      return
    }

    console.log("filters", mergeFilters(searchParams.filters, initialFilters))
    const { data, error } = await searchProductsQuery(
      {
        filters: mergeFilters(searchParams.filters, initialFilters),
        options: {
          aggregateTags: {
            ...initialFilters,
          },
          paging: {
            tot: DEFAULT_PAGE_SIZE,
            cursor: searchParams.paging.cursor,
          },
          order: searchParams.sorting,
          includeUnavailable: searchParams.includeUnavailable,
        },
      },
      true
    )

    if (error) {
      setOperation({
        ...operation,
        loading: false,
        called: true,
        ready: true,
        error,
        operationId,
        isLastResultsPage: false,
      })
      return
    }

    const currentResults =
      data?.searchProducts.results.map((x: any) =>
        toPartialGridItemProduct(x as CatalogProductDocument)
      ) ?? []
    setOperation({
      ...operation,
      loading: false,
      called: true,
      ready: true,
      error: undefined,
      totResults: data?.searchProducts.paging?.totResults,
      results: searchParams.paging.firstPage
        ? currentResults
        : [...(operation.results ?? []), ...currentResults],
      filters: toSearchFilters(
        router,
        data?.searchProducts
          .aggregations as AvailabilitySearchResultsAggregations,
        initialFilters
      ),
      initialFilters,
      isLastResultsPage: data?.searchProducts.paging?.isLastPage ?? false,
    })

    onNextCursorChange(data?.searchProducts.paging?.cursor ?? undefined)
  }

  const initSearch = async () => {
    if (!searchParams || (operation.loading && operation.called)) {
      return
    }

    const operationId = newUuid()
    setOperation({
      loading: true,
      called: true,
      ready: false,
      error: undefined,
      results: searchParams.paging.firstPage ? [] : operation.results,
      filters: undefined,
      // filters: searchParams.paging.firstPage ? undefined : operation.filters,
      operationId,
      isLastResultsPage: false,
    })

    if (searchParams.paging.firstPage) {
      onNextCursorChange(undefined)
    }

    await handleSearch(operationId)
  }

  React.useEffect(() => {
    initSearch()
  }, [searchParams])

  return <SearchProvider value={operation}>{children}</SearchProvider>
}
